class PredictiveSearch extends HTMLElement {
  constructor() {
    super();

    this.input = this.querySelector('input[type="search"]');
    this.predictiveSearchResults = this.querySelector('#predictive-search');

    this.input.addEventListener('input', this.debounce((event) => {
      this.onChange(event);
    }, 300).bind(this));
  }

  getClientWidth() {
    const bodyElement = document.querySelector('body')
    return bodyElement ? bodyElement.clientWidth : 0
  }

  onChange() {
    const searchTerm = this.input.value.trim()

    if (!searchTerm.length) {
      this.close();
      return;
    }

    this.getSearchResults(searchTerm);
  }

  getSearchResults(searchTerm) {
    fetch(`/search/suggest?q=${searchTerm}&section_id=predictive-search&resources[type]=product,article&resources[options][fields]=title,product_type,vendor,body,tag`)
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }
        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
        this.predictiveSearchResults.innerHTML = resultsMarkup;
        const showProductsButton = document.querySelector('.js-show-products-button')
        const showRecipesButton = document.querySelector('.js-show-recipes-button')
        const productsTab = document.querySelector('.js-products-results-container')
        const recipesTab = document.querySelector('.js-recipes-results-container')
        const viewMoreProducts = document.querySelectorAll('.js-search-view-more')
        const searchSection = document.querySelector('.js-main-search')

        this.open();
        this.updateHeight()

        if (viewMoreProducts) {
          viewMoreProducts.forEach((oneViewMoreProductsButton) => {
            oneViewMoreProductsButton.addEventListener('click', (event) => {
              productsTab.style.maxHeight = 'fit-content'
              searchSection.style.maxHeight = 'unset'
              oneViewMoreProductsButton.style.display = 'none'
              if (window.innerWidth >= 1024) {
                searchSection.style.height = '100%'
              }
            })
          })
        }

        if (showProductsButton && productsTab) {
          showProductsButton.addEventListener('click', () => {
            showProductsButton.classList.add('active')
            showRecipesButton.classList.remove('active')
            searchSection.classList.add('products')
            searchSection.classList.remove('recipes')

            if (window.innerWidth >= 1024) {
              productsTab.style.display = 'flex'
              recipesTab.style.display = 'none'
            } else {
              productsTab.style.display = 'grid'
              recipesTab.style.display = 'none'
            }
            this.updateHeight()
          })
        }

        if (showRecipesButton && recipesTab) {
          showRecipesButton.addEventListener('click', () => {
            showProductsButton.classList.remove('active')
            showRecipesButton.classList.add('active')
            searchSection.classList.add('recipes')
            searchSection.classList.remove('products')

            if (window.innerWidth >= 1024) {
              recipesTab.style.display = 'flex'
              productsTab.style.display = 'none'
            } else {
              recipesTab.style.display = 'grid'
              productsTab.style.display = 'none'
            }
            this.updateHeight()
          })
        }

        this.updateVisibleProductCards()


      })
      .catch((error) => {
        this.close();
        throw error;
      });

    fetch(`/search/suggest.json?q=${searchTerm}&resources[type]=product,article&resources[options][fields]=title,product_type,vendor,body,tag`)
      .then((response) => {
        return response.json()
      })
      .then((data) => {
        const results = data.resources.results
        const thereAreProducts = results.products.length !== 0
        const thereAreArticles = results.articles.length !== 0

        if (!thereAreArticles && !thereAreProducts) {
          this.showNoResults()
          this.updateHeight()
        } else {
          this.hideNoResults()
        }
      })
      .catch((error) => {
        console.error(error)
      })

    window.gtag &&
      window.gtag('event', 'predictive_search_query_new', {
        page_path: window.location.pathname,
        search_query: searchTerm
      })
  }

  open() {
    this.predictiveSearchResults.style.display = 'block';
  }

  close() {
    this.predictiveSearchResults.style.display = 'none';
    this.showNoResults()
  }

  updateHeight() {
    const productsContainer = document.querySelector('.js-products-results-container')
    const searchSection = document.querySelector('.js-main-search')
    const wrapperHeight = `${(document.querySelector('.js-predictive-search-wrapper').offsetHeight + 20).toString()}px`
    if (window.innerWidth >= 1024) {
      searchSection.style.maxHeight = wrapperHeight
    } else {
      searchSection.style.maxHeight = 'calc(100% - var(--header-height))'
    }
    searchSection.style.overflowY = 'auto'

    if (productsContainer) {
      const hasOverflow = productsContainer.scrollHeight / productsContainer.clientHeight > 1.2 // this accounts for extra paddings that need to be added in
      if (hasOverflow) {
        document.querySelector('.js-search-view-more-desktop-container').style.display = 'flex'
      } else {
        document.querySelector('.js-search-view-more-desktop-container').style.display = 'none'
      }
    }
  }

  updateVisibleProductCards() {
    const container = document.querySelector('.js-products-results-container')

    if (!container) {
      return
    }

    const cards = document.querySelectorAll('.js-predictive-search-card')
    const tallestCardHeight = Math.max(...Array.from(cards).map(card => card.offsetHeight))

    container.style.maxHeight = this.getClientWidth() < 1024 ?
      `${tallestCardHeight * 3}px` :
      `${tallestCardHeight}px`

    cards.forEach((card) => {
      card.style.minHeight = `${tallestCardHeight}px`
    })
  }

  hideNoResults() {
    const noResults = document.querySelector('.js-no-search-results-container')
    noResults.style.display = 'none'
  }

  showNoResults() {
    const noResults = document.querySelector('.js-no-search-results-container')
    if (window.innerWidth >= 1024) {
      noResults.style.display = 'flex'
    } else {
      noResults.style.display = 'block'
    }
  }

  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}

customElements.define('predictive-search', PredictiveSearch);
